import { TemplateElement, html, defineElement, when } from '@webtides/element-js';
import style from './content-cards-overview-section.css';
import '../../../card-tag/card-tag.js';
import '../content-cards/content-cards.js';

/**
 * @typedef {Object} ContentCardProperties
 * @property {string} icon
 * @property {string} headline
 * @property {string} text
 */

/**
 * @property {string} name
 * @property {string} icon
 * @property {string} label
 * @property {ContentCardProperties[]} cards
 * @property {LinkProperties} link
 * @property {boolean} selected
 */
export default class ContentCardsOverviewSection extends TemplateElement {
    constructor() {
        super({ styles: [style], propertyOptions: { selected: { reflect: true } } });
    }

    properties() {
        return {
            name: '',
            icon: '',
            label: '',
            cards: [],
            link: undefined,
            selected: false,
        };
    }

    events() {
        return {
            window: {
                'mb-filter-change': (event) => {
                    this.selected = event.detail?.name === this.name;
                },
            },
            'mb-card-tag': {
                'mb-change': (event) => {
                    const selected = event.detail;
                    const selectedCategoryName = selected ? event.target.getAttribute('name') : '';
                    this.dispatch(
                        'mb-filter-change',
                        selected && selectedCategoryName === this.name
                            ? { name: this.name, icon: this.icon, label: this.label }
                            : undefined,
                    );
                },
            },
        };
    }

    template() {
        return html`
            <mb-card-tag
                class="md:hidden mb-16"
                slot="tags"
                name="${this.name}"
                icon="${this.icon}"
                label="${this.label}"
                selected="${this.selected}"
            ></mb-card-tag>
            ${when(
                this.cards.length > 0,
                html`
                    <div class="content">
                        <h3 class="text-lg text-green-medium font-medium mb-24">${this.label}</h3>
                        <mb-content-cards
                            class="mb-40 md:mb-80"
                            .cards="${this.cards}"
                            .link="${this.link}"
                        ></mb-content-cards>
                    </div>
                `,
            )}
        `;
    }
}

defineElement('mb-content-cards-overview-section', ContentCardsOverviewSection);
